import React from 'react';
import Slide from '@material-ui/core/Slide';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import { Button } from 'antd';
import { Api } from '../../config/api';
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
export default function NFTReedem({
  isOpened = false,
  handleClose,
  handleDelete,
  redeemBtnLoading,
}) {
  return (
    <Dialog
      open={isOpened}
      TransitionComponent={Transition}
      keepMounted={false}
      onClose={handleClose}
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
      fullWidth
      style={{ zIndex: 1000 }}
      maxWidth="sm"
    >
      <div className="dialog-titlebar-medium">
        <div className="dialog-title-medium">Confirmation</div>
      </div>

      <div className="bg-blueGray-100">
        <p className="mt-6 text-md leading-relaxed text-blueGray-600 delete_box_padding">
          Are you sure, you want to Redeem ("burn") this NFT?
        </p>
        <DialogActions style={{ marginTop: 10, height: 50 }}>
          <div style={{ minWidth: 100, textAlign: 'center', display: 'flex' }}>
            <Button
              className="bg-blueGray-700 active:bg-blueGray-600 uppercase text-white font-bold hover:shadow-md shadow text-xs px-4 py-2 rounded outline-none focus:outline-none sm:mr-2 mb-1 ease-linear transition-all duration-150"
              style={{
                borderColor: 'rgba(51, 65, 85, 1)',
                background: 'rgba(51, 65, 85,1)',
                color: '#fff',
              }}
              onClick={handleClose}
            >
              Cancel
            </Button>

            <div
              style={{
                display: 'flex',
                minWidth: 90,
                justifyContent: 'center',
              }}
            >
              <Button
                className="bg-blueGray-700 active:bg-blueGray-600 uppercase text-white font-bold hover:shadow-md shadow text-xs px-4 py-2 rounded outline-none focus:outline-none sm:mr-2 mb-1 ease-linear transition-all duration-150"
                style={{
                  borderColor: 'rgba(51, 65, 85, 1)',
                  background: 'rgba(51, 65, 85,1)',
                  color: '#fff',
                }}
                loading={redeemBtnLoading}
                onClick={() => {
                  handleDelete();
                }}
              >
                Confirm Redeem
              </Button>
            </div>
          </div>
        </DialogActions>
      </div>
    </Dialog>
  );
}
